"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { COOKIE_CONSENT_KEY } from "@/lib/i18n";
import { isNativeAppClient } from "@/lib/native-app";
import { Button } from "./ui/button";
import { usePrefs } from "./prefs-provider";

export function CookieConsent() {
  const { t } = usePrefs();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isNativeAppClient()) return;
    try {
      if (localStorage.getItem(COOKIE_CONSENT_KEY) !== "1") setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  function accept() {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, "1");
    } catch {
      /* ignore */
    }
    setShow(false);
  }

  const c = t.cookieBanner;

  return (
    <AnimatePresence>
      {show ? (
        <div className="cookie-banner pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex justify-center p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:p-4">
          <motion.div
            role="region"
            aria-label={c.title}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 16 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="pointer-events-auto flex w-full max-w-xl flex-col gap-3 rounded-2xl border border-line bg-surface p-4 shadow-3 sm:flex-row sm:items-center"
          >
            <Cookie className="hidden h-5 w-5 shrink-0 text-brand sm:block" aria-hidden />
            <p className="flex-1 text-xs leading-relaxed text-ink-2">
              {c.message}{" "}
              <Link href="/privacy" className="font-semibold text-brand underline-offset-2 hover:underline">
                {c.privacyLink}
              </Link>
            </p>
            <Button size="sm" onClick={accept} className="shrink-0 self-end sm:self-center">
              {c.accept}
            </Button>
          </motion.div>
        </div>
      ) : null}
    </AnimatePresence>
  );
}
